import React, { useState, useEffect, Fragment} from "react";
import { useNavigate } from "react-router-dom";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
import String from "../../lang/String";
import store from "../../redux/Store";
import appleStore  from  "../../assets/app_store_bttn.png";
import playStore  from  "../../assets/play_store_bttn.png";
import { useSelector } from "react-redux";

function Footer(props) {
  const navigate = useNavigate()
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const { option } = props;
    const RdxCate = useSelector((state) => state.HdCat.value);
   const [Category, setCategory] = useState(
      RdxCate && Object.keys(RdxCate).length > 0 && RdxCate.data.length > 0
        ? RdxCate
        : []
    );
  // console.log("permission", option)
  useEffect(() => {
      const handleResize = () => {
        setWindowSize(window.innerWidth)
      }
  
      window.addEventListener('resize', handleResize)
  
      return () => window.removeEventListener('resize', handleResize)
    }, [])
  const [SideMenu, setSideMenu] = useState([])
  useEffect(() => {
    sideMenu();
  }, [])
  const exclue = useSelector((state) => state.exclue.val);
  // console.log(exclue)
  const sideMenu = () => {
    ApiCall('sidemenu', {}).then((data) => {
      // console.log("Home", data)
      if(data.message == 'Success'){
        setSideMenu(data.result);
      }
    }).catch(err=>console.log(err));
  }
  // console.log("sideMenu -->", SideMenu);

  const d = new Date();
  let year = d.getFullYear();

  const callFilter = (id) => {
    console.log("Call Filter Footer", id)
    store.dispatch({ type: "setTypeparams", payload: id });
    if(option){
      props.reload(Math.random().toString(36).slice(2, 7))
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    navigate('/filter');
    
  }

  const goPrivacyFun = () => {
    navigate("/privacy-policy")
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const gotermsFun = () => {
    navigate("/terms-use")
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const goContactFun = () => {
    navigate("/contact")
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const goAboutUs = () => {
    navigate('/about-us')
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const goContactUs = () => {
    navigate('/Contact')
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    SideMenu.length > 0 &&
    <div style={{ backgroundColor: "#FFF4F7", borderTop: `2px solid #126a38` }} className="p-4">
      <div className="container">
        <div class="row">
          
          <div class={windowSize > 512 ? "col-12 col-md-3" : "col-12 col-md-3"}>
            <p style={{color: Colors.light_black}} className={windowSize > 512 ? "py-3 h3" : "py-3 h3 text-center"}>{String.footer_text.col_3.title}</p>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goPrivacyFun}
                >{String.footer_text.col_3.privacy_policy}</span>
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={gotermsFun}>{String.footer_text.col_3.terms_of_use}</span>
              {/* <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goAboutUs}>About Us</span> */}
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p"  onClick={gotermsFun} >{String.footer_text.col_3.return_policy}</span>
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p"  onClick={gotermsFun} >{String.footer_text.col_3.shipping_olicy}</span>
            </div>
          </div>
          <div class={windowSize > 512 ? "col-12 col-md-3" : "col-12 col-md-3"}>
            <p style={{color: Colors.light_black}} className={windowSize > 512 ? "py-3 h3" : "py-3 h3 text-center"}>About Us</p>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" >We’ve turned the wheel full circle at Theni Kamadhenu, by building a culture that thrives on the principles of health, ecology, fairness and care. From nurturing our soil and crops with unadulterated nourishment to testing each product for 250 pesticides, we follow the highest standards of quality and hygiene.</span>
            </div>
          </div>
          <div class={windowSize > 512 ? "col-12 col-md-3" : "col-12 col-md-3"}>
            <p style={{color: Colors.light_black}} className={windowSize > 512 ? "py-3 h3" : "py-3 h3 text-center"}>{String.footer_text.col_2.title}</p>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goAboutUs}>About Us</span>
            </div>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goContactUs}>Contact Us</span>
            </div>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goContactUs}>Blogs</span>
            </div>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <span style={{cursor: 'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={goContactUs}>Offers</span>
            </div>
          </div>
          <div class={windowSize > 512 ? "col-12 col-md-3" : "col-12 col-md-3"}>
            <p style={{color: Colors.light_black}} className={windowSize > 512 ? "py-3 h3" : "py-3 h3 text-center"}>{String.footer_text.col_1.title}</p>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              {/* {SideMenu && SideMenu[0].data.length > 0 && (
                SideMenu[0].data.slice(0,4).map((data) => {
                  return (
                    <Fragment key={data.id}>
                    <span style={{cursor:'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={() => callFilter(data.id)}>{data.category_name}</span>
                    </Fragment>
                  )
                })
              )} */}

              {Category.data && Category.data.length > 0 && (Category.data.map((data) => { 
                 return (
                  <Fragment key={data.id}>
                  <span style={{cursor:'pointer'}} className="font-weight-bold py-1 h6 footer-p" onClick={() => callFilter(data.id)}>{data.category_name}</span>
                  </Fragment>
                )
              }))}
              {/* <span className="font-weight-bold py-1 h6 footer-p">{String.footer_text.col_1.diamond}</span>
              <span className="font-weight-bold py-1 h6 footer-p">{String.footer_text.col_1.gold}</span>
              <span className="font-weight-bold py-1 h6 footer-p">{String.footer_text.col_1.silver}</span>
              <span className="font-weight-bold py-1 h6 footer-p">{String.footer_text.col_1.platinum}</span> */}
            </div>
          </div>
          <div class={windowSize > 512 ? "col-12 col-md-3" : "col-12 col-md-3"}>
            <p  style={{color: Colors.light_black}} className={windowSize > 512 ? "py-3 h3" : "py-3 h3 text-center"}>{String.footer_text.col_4.title}</p>
            <div
              className={windowSize > 512 ? "d-flex flex-column" : "d-flex flex-column align-items-center"}
              style={{ color: Colors.Base_color }}
            >
              <div className="d-flex flex-row" style={{
                gap:'15px'
              }}>
                {/* <img
                  className=""
                  src={images.Fwhatsapp}
                  alt="icons"
                  width="45"
                  height="30"
                /> */}
                <i class="fa-brands fa-whatsapp" style={{
                  color:Colors.Base_color,
                  fontSize: '30px'
                }}></i>
                {/* <img
                  className="mx-2"
                  src={images.Fphone}
                  alt="icons"
                  width="30"
                  height="30"
                /> */}
                <i class="fa-solid fa-phone" style={{
                  color:Colors.Base_color,
                  fontSize: '30px'
                }}></i>
                {/* <img
                  className="mx-2"
                  src={images.Fmail}
                  alt="icons"
                  width="30"
                  height="30" role={ "button" } onClick={goContactFun}
                /> */}
                <i class="fa-regular fa-envelope" style={{
                  color:Colors.Base_color,
                  fontSize: '30px'
                }}></i>
              </div>
              {/* <span
                className={windowSize > 512 ? "font-weight-bold py-2 h6 footer-p" : "font-weight-bold py-2 h6 footer-p text-center"}
                style={{ lineHeight: "25px" }}
              >
                {String.footer_text.col_4.text}
              </span> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col d-flex flex-column justify-content-center align-items-center" style={{padding: 0}}>
            {/* <p style={{color: Colors.light_black}} className="py-2 h3 text-center">{String.footer_text.download_our_app}</p>
            <div className="row justify-content-sm-center">
              

              <div className="row" style={{textAlign: "center"}}>
                  <div className="col-lg-6 col-sm-12 ">
                    <img
                    className="mx-2"
                    src={appleStore}
                    alt="icons"
                    // width="200"
                    height="50"
                  />
                  </div>

                  <div className="col-lg-6 col-sm-12 gap-2 appleLogo">
                    <img
                    className="mx-2"
                    src={playStore}
                    alt="icons"
                    // width="200"
                    height="50"
                  />
                  </div>
                </div>
            </div> */}
            <p className="text-secondary my-3 text-center footer-p">
              © {year} {Web_url.App_Name}. {String.footer_text.all_rights_reserved}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
